import { connect } from 'react-redux'
import { storeAppConfig, storeLocations } from 'actions'

const mapStateToProps = () => ({})
const withRedux = connect(mapStateToProps, { storeAppConfig, storeLocations })

export default withRedux
